import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const WelcomeSection = ({ id }) => {
  const [QWSList, setQWSList] = useState([]);

  // Fetch data from API
  const fetchData = async () => {
    try {
      const response = await corefetch(
        `WelcomeSection/GetAboutSectionList?displayesInID=${id}`
      );
      if (response && response.length > 0) {
        setQWSList(response);
      } else {
        setQWSList([]);
      }
    } catch (error) {
      setQWSList([]);
      console.error("Error fetching list:", error);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();
  }, [id]);

  // Return null if no data is found
  if (!QWSList || QWSList.length === 0) {
    return null;
  }

  return (
    <section className="static-hero-s2">
      <div className="hero-container">
        <div className="hero-inner">
          <div className="container">
            <div className="row align-items-center">
              {QWSList.map((item) => (
                <React.Fragment key={item.id}>
                  <div className="col-xl-6 col-lg-6 col-12">
                    <div className="wpo-static-hero-inner">
                      <div
                        className="shape-1 wow fadeInUp"
                        data-wow-duration="900ms"
                        style={{
                          visibility: "visible",
                          animationDuration: "900ms",
                          animationName: "fadeInUp",
                        }}
                      >
                        <img
                          src="assets/images/Wedding/shape5.png"
                          alt="Shape 1"
                        />
                      </div>
                      <div
                        className="slide-title wow fadeInUp"
                        data-wow-duration="1100ms"
                        style={{
                          visibility: "visible",
                          animationDuration: "1100ms",
                          animationName: "fadeInUp",
                        }}
                      >
                        <h2>{item.title}</h2>
                      </div>
                      <div
                        className="slide-text wow fadeInUp"
                        data-wow-duration="1300ms"
                        style={{
                          visibility: "visible",
                          animationDuration: "1300ms",
                          animationName: "fadeInUp",
                        }}
                      >
                        <p>{item.description}</p>
                      </div>
                      <div
                        className="slide-text wow fadeInUp"
                        data-wow-duration="1300ms"
                        style={{
                          visibility: "visible",
                          paddingTop: 40,
                          animationDuration: "1300ms",
                          animationName: "fadeInUp",
                        }}
                      ></div>
                      <div
                        className="shape-2 wow fadeInUp"
                        data-wow-duration="1700ms"
                        style={{
                          visibility: "visible",
                          animationDuration: "1700ms",
                          animationName: "fadeInUp",
                        }}
                      >
                        <img
                          src="assets/images/Wedding/shape6.png"
                          alt="Shape 2"
                        />
                      </div>
                      <div className="clearfix" />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-12">
                    <div className="static-hero-right">
                      <div className="static-hero-img">
                        <div
                          className="static-hero-img-inner wow zoomIn"
                          data-wow-duration="1500ms"
                          style={{
                            visibility: "visible",
                            animationDuration: "1500ms",
                            animationName: "zoomIn",
                          }}
                        >
                          <img
                            src={`${ImageURL}${item.imagePath}`}
                            alt="Portrait"
                          />
                        </div>
                      </div>
                      <div className="static-hero-shape">
                        <img
                          src="assets/images/Wedding/frame.png"
                          alt="Frame"
                        />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
